const cloudTbUrl = 'https://cloud.socialwalls.com/react-app/media/'

export const baseUrl = pathname => cloudTbUrl + pathname;

export const cloudUrl = pathname => cloudTbUrl + pathname;

export const FontAwesomeIcon = ({ type, icon, size, iconClass, onClick, className }) => <i className={`${type ? `fa-${type}` : `fa-regular`} fa-${icon.includes("twitter") ? 'x-twitter' : icon} ${className ? className : ''} ${iconClass ? iconClass : ''}`} style={{ fontSize: size }} onClick={onClick || (() => { })}></i>

export const ErrImg = baseUrl(`images/no-image1.svg`);

export const ProductPlaceholder = baseUrl(`media/images/error/no-product.svg`);